define([
    "./nlgPaginationModule",
    "./nlgPaginationDirective"
], function(){});